// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_RL6Qs","content":"index_content_CGPZN","arrowClose":"index_arrowClose_jUNZT"};